import { Link } from 'react-router-dom';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './dropdown-menu.scss';
import { useMemo } from 'react';
import { dropdownMenuIcons } from './dropdown-menu-icons';

type DropdownMenuItem = {value: string, label: string, to: string};

export function convertEnumToDropdownItems(enumType: any): DropdownMenuItem[] {
    return Object.entries(enumType).map(([key, value]) => ({
        to: (value as string).replace(' ', '-').toLowerCase(),
        label: value as string,
        value: value as string,
    }));
}

interface DropdownMenuProps {
    items: {value: string, label: string, to: string}[];
    activeSubMenu: string;
}
export const DropdownMenu: React.FC<DropdownMenuProps> = ({ items, activeSubMenu }) => {

    const icon = dropdownMenuIcons[activeSubMenu];

    const menuConfig = useMemo(() => {
        return {
            items:
                items.map(item => (
                    {key: item.value, label: <Link
                        to={item.to}
                        key={item.value}
                        data-testid={`dropdown-menu-${item.value}`}
                    >
                        {item.label}
                    </Link>}
                )),
            selectable: true,
            selectedKeys: [activeSubMenu]
        };
    }, [activeSubMenu]);

    return <div className="dropdown-menu-wrapper">
        <Dropdown overlayClassName={'dropdown-overlay-menu'} menu={menuConfig} trigger={['click']}>
            <span>
                {icon}
                {items.find(_ => _.value === activeSubMenu)?.label}
                <DownOutlined />
            </span>
        </Dropdown>
    </div>;
};
